import { storageSession } from "@pureadmin/utils";
import { useUserStoreHook } from "@/store/modules/user";
// import ADMINAUTH, { routeMap, iconMap } from "@/router/admin_router";
import ADMINAUTH from "@/router/modules/admin_router";
import routeMap from "@/router/modules/router_map";
import iconMap from "@/router/modules/icon_map";
import type { RouteConfigsTable } from "/#/index";

export interface DataInfo {
  /** token */
  userToken: string;
  /** 手机号 */
  telNo?: string;
  uid?: string;
  countryCode?: string;
  merchantNo?: string;
  model?: object;
  /** 当前登陆用户的角色只有 */
  userType: "ADMIN" | "OPERATOR";
  channelCode?: string;
  menuPermisionModelList?: Array<RouteConfigsTable>;
}

export const sessionKey = "user-info";
export const TokenKey = "authorized-token";

/** 获取`token` */
export function getToken(): DataInfo {
  // 此处与`TokenKey`相同，此写法解决初始化时`Cookies`中不存在`TokenKey`报错
  return storageSession.getItem(sessionKey);
}

// 添加匹配到的children列表（二级），服务端只返回一级的权限列表
function addRightsChildrenToRoute(router) {
  if (useUserStoreHook().userType === "ADMIN") return router;
  router.forEach(item => {
    const icon = iconMap[item.path];
    icon && (item.meta.icon = iconMap[item.path]); // 服务端未返回icon，为一级路由菜单添加icon
    const children = item.children ?? [];
    children.forEach(route => {
      const childrenRoute = routeMap[route.path] ?? [];
      item.children = [...item.children, ...childrenRoute];
    });
  });
  return router;
}

// 去除不包含path的路由项, 添加后端返回标识
function filterNoPathRouter(router) {
  router = router
    .filter(item => !!item.path)
    .map(item => ({
      ...item,
      meta: {
        ...item.meta,
        backstage: true // 添加后端返回标识
      }
    }));
  router.forEach(item => {
    if (item.children) item.children = filterNoPathRouter(item.children);
  });
  return router;
}

/**
 * @description 设置`token
 */
export function setToken(data: DataInfo) {
  const { telNo, userType, userToken, merchantNo, uid, model, channelCode } =
    data;
  // admin权限不会传
  let menuPermisionModelList = data.menuPermisionModelList || ADMINAUTH;
  menuPermisionModelList = addRightsChildrenToRoute(
    filterNoPathRouter(menuPermisionModelList)
  );
  useUserStoreHook().SET_TELNO(telNo);
  useUserStoreHook().SET_UID(uid);
  useUserStoreHook().SET_USERTYPE(userType);
  useUserStoreHook().SET_MENUPERMISION(menuPermisionModelList);
  useUserStoreHook().SET_MERCHANTNO(merchantNo);
  useUserStoreHook().SET_Model(model);
  useUserStoreHook().SET_ChannelCode(channelCode);
  storageSession.setItem(sessionKey, {
    telNo,
    userType,
    userToken,
    merchantNo,
    uid,
    model,
    channelCode,
    menuPermisionModelList
  });
  // }
}

/** 删除`token`以及key值为`user-info`的session信息 */
export function removeToken() {
  sessionStorage.removeItem(sessionKey);
}

/** 格式化token（jwt格式） */
export const formatToken = (token: string): string => {
  return "Bearer " + token;
};
